import { useEffect, useState } from 'react';

export const useLineAuth = () => {
  const [lineToken, setLineToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('lineToken');
    setLineToken(token);
    setLoading(false);
  }, []);

  return {
    lineToken,
    isAuthenticated: Boolean(lineToken),
    loading,
  };
}